import { useEffect, useState } from 'react';
import { getWindowState, WindowState } from '../utils/whatsappWindow';

const TICK_MS = 60 * 1000;

/**
 * Live WhatsApp 24h-window state for a contact. Recomputes every minute and
 * whenever `lastInboundAt` (or any extra dep) changes; the interval is
 * cleared on unmount so a chip never ticks after its panel is gone.
 */
export function useWhatsappWindow(lastInboundAt?: string | null, deps: any[] = []): WindowState {
  const [state, setState] = useState<WindowState>(() => getWindowState(lastInboundAt));

  useEffect(() => {
    setState(getWindowState(lastInboundAt));
    if (!lastInboundAt) return undefined;
    const id = globalThis.setInterval(() => setState(getWindowState(lastInboundAt)), TICK_MS);
    return () => globalThis.clearInterval(id);
  }, [lastInboundAt, ...deps]);

  return state;
}

export default useWhatsappWindow;
